import { useCallback, useMemo, useRef } from 'react'

import type { GLTFData, ModelInterface } from '../types'

type ModelGLTFData = Record<string, GLTFData>

interface UseVRAMTrackerArgs {
  activeModel: ModelInterface | undefined
}

const useVRAMTracker = ({ activeModel }: UseVRAMTrackerArgs) => {
  const modelGLTFData = useRef<ModelGLTFData>()

  const unassignedModelId = useMemo(() => {
    if (activeModel?.gltfSrc && activeModel?.hdr) {
      return `${activeModel.gltfSrc}${activeModel.hdr}`
    }
    return undefined
  }, [activeModel])

  const activeModelId = activeModel
    ? activeModel.id || unassignedModelId
    : undefined

  const activeModelGLTFData = activeModelId
    ? modelGLTFData.current?.[activeModelId]
    : undefined

  const setGLTFData = useCallback(
    (modelId?: string) => (data: GLTFData) => {
      const index = modelId || unassignedModelId
      if (!index) {
        return
      }
      modelGLTFData.current = {
        ...modelGLTFData.current,
        [index]: data,
      }
    },
    [unassignedModelId]
  )

  return {
    activeModelGLTFData,
    setGLTFData,
  }
}

export default useVRAMTracker
